import pathOr from 'ramda/src/pathOr';
import { SET_CATEGORY, SET_UI_FILTER } from '../../../constants/filter';
import { DEFAULT_CATEGORY } from '../../../constants/categories';

export const initialState = {
  category: DEFAULT_CATEGORY,
};

const filter = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CATEGORY:
      return { ...state, category: payload };

    case SET_UI_FILTER: {
      return { ...state, ...payload };
    }

    default:
      return state;
  }
};

export default filter;

/**
 * SELECTOR
 */
export const uiFilterSelector = (state) =>
  pathOr(initialState, ['ui', 'filter'], state);
